export default __webpack_public_path__ + "static/media/icon-search.2d88fac3.svg";